// removed by extract-text-webpack-plugin
module.exports = {"root":"IR76f","feature":"_2b_h-"};